import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ProductHistoryListTemplate } from "themes/application/product/pages";
import { ProductHistoryListViewStore } from "application/product/stores";

@setCurrentView(rootStore => new ProductHistoryListViewStore(rootStore), "productHistoryListViewStore")
@observer
class ProductHistoryList extends React.Component {
    render() {
        return <ProductHistoryListTemplate {...this.props} />;
    }
}

export default ProductHistoryList;